
import { IAdapterConfig } from "@care-portals/api-interfaces";
import type { MiddlewareConfigClass } from "@care-portals/api-interfaces";

const config = {
  digitalRx: {
    label: 'DigitalRx',
    functions: {
      CreateOrder: {
        middlewareHandler: 'digital-rx',
        version: 2,
        label: 'Create Order',
        pipelines: ["order"],
        passPayload: true
      },
      HandleWebhook: {
        middlewareHandler: 'digital-rx',
        version: 2,
        label: 'Handle Webhook',
        "pipelines": ['webhook'],
        passPayload: true
      },
    }
  }
} as const

export const DigitalRxConfig: IAdapterConfig = { ...config } as unknown as IAdapterConfig

export type DigitalRxFunctionConfiguration = MiddlewareConfigClass<typeof config.digitalRx.functions>